// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {EditorlistScreenLayout} from 'app_components/screens/editor/editorlist'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import types
// @end

// @ADD Component types
interface IEditorlistScreenProps {
  history?: any
}

interface IEditorlistScreenState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class EditorlistScreen extends Component<IEditorlistScreenProps, IEditorlistScreenState> {

  public moduleName: string = 'module:survey'
  private permission: PermissionService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IEditorlistScreenProps) {
    super(props)
    this.state = {}

    this.permission = new PermissionService(this.moduleName)
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <EditorlistScreenLayout
        {...this.props}
        permission={this.permission}
      />
    )
  }
}

export default connect(mapStatesToProps)(EditorlistScreen)
